import { List, Map } from "immutable";

export const getDocumentsStore = (state) => state.documents;
export const getSignatureTemplates = (state) => getDocumentsStore(state).get("signatureTemplatesList", List());
export const getSignatureTemplate = (state, templateID) =>
	getDocumentsStore(state).getIn(["signatureTemplates", templateID], Map());
export const getSignatureTemplateSteps = (state, templateID) =>
	getSignatureTemplate(state, templateID).get("signers", List());
